import React, { useState, useContext, useEffect } from 'react';
import style from './Classmates.module.css';

import { AppContext } from '../../../AppContext';
import icons from '../../../icons';
import Checkbox from '../../Checkbox/Checkbox';
import IconButton from '../../Buttons/IconButton/IconButton';
import TextButton from '../../Buttons/TextButton/TextButton';

import { db } from '../../../firebase';
import { doc, updateDoc } from 'firebase/firestore';

import Lottie from "lottie-react";
import students_animation from "../../../lottieAnimations/students_animation.json"
import Banner from '../../Banner/Banner';



const Classmates = () => {
    const { users, user, setUser, classPresidents, setClassPresidents, setPage } = useContext(AppContext);
    const [classPresidentsVote, setClassPresidentsVote] = useState([]);
    const [validatingPresidents, setValidatingPresidents] = useState(false);
    const [showInfo, setShowInfo] = useState(false);

    useEffect(() => {
        const voted = [];
        Object.entries(classPresidents).forEach(([key, votes]) => {
            if (key !== "winners" && votes.includes(user.id))
                voted.push(key);
        })

        setClassPresidentsVote(voted);
    }, [classPresidents]);

    return <main className={ style.main } onClick={ () => setShowInfo(false) }>
        <Banner id="classmates" />
        <div className={ style.modal } style={{ transform: showInfo && "translateY(-50%)" }}>
            <img src={ icons.info_icon } className={ style.modalIcon }></img>
            <h3 className={ style.modalText }>
                I rappresentanti di classe possono pubblicare annunci visibili a tutta la classe, utili per comunicare le notizie importanti!<br></br><br></br>
                Sei un rappresentante di classe? Clicca su "Candidati"!
            </h3>
            <TextButton text="CHIUDI" style={{ marginTop: "1.5rem", marginLeft: "3rem", marginRight: "3rem" }} />
        </div>
        <div style={{ display: "flex" }}>
            <h3 className={ style.sectionHeader } style={{ marginBottom: "0" }}>Rappresentanti di classe</h3>
            <img src={ icons.info_icon } style={{ marginTop: "auto", marginLeft: "1rem" }} onClick={ e => {
                e.stopPropagation();
                setShowInfo(oldShowInfo => !oldShowInfo);
            } }></img>
        </div>
        { Object.keys(users).length > 3 ? <section>
            <div className={ style.users }>
                { Object.values(users ?? {}).filter(classmate => classPresidents?.winners?.includes(classmate.id)).map(classmate => <div className={ style.user } key={ `classmates-${classmate.id}` }>
                    <img src={ classmate.profilePicture || `https://eu.ui-avatars.com/api/?name=${classmate.username}&background=d86c07&rounded=true&format=svg&color=fff` } referrerPolicy="no-referrer" className={ style.userIcon }></img>
                    <div className={ style.userDetails }>
                        <h4 className={ style.username } style={{ marginTop: classmate.id === user.id && "0" }}>{ classmate.id === user.id ? "Tu" : classmate.username }</h4>
                        { classmate.id !== user.id && <h5 className={ style.userEmail }>{ classmate.email }</h5> }
                    </div>
                    { user?.invitedFriendsEmails?.includes(classmate.email) && <img src={ icons.invite_orange_icon } className={ style.invitedIcon }></img> }
                </div>) }
            </div>
            <IconButton onClick={ () => {
                if (validatingPresidents) {
                    const newClassPresidents = {};

                    Object.entries(classPresidents).forEach(([candidate, votes]) => {
                        if (candidate === "winners") return;

                        if (classPresidentsVote.includes(candidate)) newClassPresidents[candidate] = [ ...votes, user.id ];
                        else newClassPresidents[candidate] = votes.filter(vote => vote !== user.id);
                    });

                    classPresidentsVote.forEach(vote => {
                        if (newClassPresidents[vote] == undefined)
                            newClassPresidents[vote] = [ user.id ];
                    });

                    newClassPresidents.winners = [];

                    Object.entries(newClassPresidents).forEach(([candidate, votes]) => {
                        if (candidate === "winners") return;

                        if (votes.length > Object.keys(users).length / 2)
                            newClassPresidents.winners.push(candidate);
                    });

                    updateDoc(doc(db, `schools/${user.school}/classes/${user.class}`), { presidents: newClassPresidents });
                    setClassPresidents(newClassPresidents);
                }

                setValidatingPresidents(oldValidating => !oldValidating);
            } } text={ validatingPresidents ? "Conferma" : "Riconosci rappresentanti" } textStyle={{ fontSize: ".8rem" }} icon={ validatingPresidents ? icons.check_icon : icons.announcement_icon } background={ !validatingPresidents && "linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" } style={{ paddingTop: ".25rem", paddingBottom: ".25rem", marginTop: "1rem" }} />
            { !validatingPresidents && !classPresidents.winners?.includes(user.id) && <IconButton onClick={ () => {
                updateDoc(doc(db, `users/${user.id}`), { classPresidentCandidate: !user.classPresidentCandidate });
                setUser(oldUser => ({ ...oldUser, classPresidentCandidate: !oldUser.classPresidentCandidate }))
            } } text={ user.classPresidentCandidate ? "Candidato" : "Candidati" } textStyle={{ fontSize: ".8rem" }}  icon={ user.classPresidentCandidate ? icons.check_icon : icons.announcement_white_icon } background={ user.classPresidentCandidate && "linear-gradient(to left, rgb(10, 107, 2), rgb(5, 209, 56))" } style={{ paddingTop: ".25rem", paddingBottom: ".25rem", marginTop: "1rem" }} /> }
            { !validatingPresidents && classPresidents.winners?.includes(user.id) && <IconButton onClick={ () => setPage({ page: "announcement" }) } textStyle={{ fontSize: ".8rem" }} text="Nuovo annuncio" icon={ icons.add_icon } iconStyle={{ width: "1rem" }} style={{ paddingTop: ".25rem", paddingBottom: ".25rem", marginTop: "1rem" }} /> }
        </section> : <section>
            <Lottie 
                style={{ backgroundColor: "rgb(44, 44, 44)", marginTop: "1rem" }}
                loop={ false }
                autoplay={ true }
                animationData={ students_animation }
                height={ 300 }
                width={ 300 } />
            <h5 className={ style.infoHeader }>La tua classe deve avere almeno <span style={{ color: "var(--orange)" }}>6 utenti</span> per poter riconoscere i rappresentanti di classe!</h5>
        </section> }
        <h3 className={ style.sectionHeader } style={{ marginTop: "2rem", marginBottom: "0" }}>{ validatingPresidents ? "Rappresentanti candidati" : "I tuoi compagni di classe" }</h3>
        <section>
            <div className={ style.users }>
                { Object.values(users ?? {}).filter(classmate => classmate.id !== user?.id && (!validatingPresidents || classmate.classPresidentCandidate)).map(classmate => <div className={ style.user } key={ `classmates-${classmate.id}` }>
                    <img src={ classmate.profilePic|| `https://eu.ui-avatars.com/api/?name=${classmate.username}&background=d86c07&rounded=true&format=svg&color=fff` } className={ style.userIcon }></img>
                    <div className={ style.userDetails }>
                        <h4 className={ style.username }>{ classmate.username }</h4>
                        <h5 className={ style.userEmail }>{ classmate.email }</h5>
                    </div>
                    { validatingPresidents && <Checkbox id={ `class-president-candidate-${classmate.id}` } checked={ classPresidentsVote.includes(classmate.id) } onChange={ e => setClassPresidentsVote(oldVotes => e.target.checked ? [...oldVotes, classmate.id] : oldVotes.filter(vote => vote !== classmate.id)) } style={{ marginRight: ".5rem" }} /> }
                </div>) }
            </div>
        </section>
    </main>;
};

export default Classmates;